import about from "../media/about.png";
import artemisa from "../media/artemisa.png";
import bootstrap from "../media/bootstrap.png";
import css from "../media/css.png";
import css2 from "../media/css2.png";
import dev from "../media/dev.png";
import fondoCss from "../media/Fondocss.mp4";
import git from "../media/git.png";
import git2 from "../media/git2.png";
import github from "../media/github.png";
import html from "../media/html.png";
import html2 from "../media/html2.png";
import javascript from "../media/javascript.png";
import javascript2 from "../media/javascript2.png";
import moviesWeb from "../media/moviesweb.png";
import nodejs from "../media/nodejs.png";
import nodejs2 from "../media/nodejs2.png";
import react from "../media/react.png";
import react2 from "../media/react2.png";
import wave1 from "../media/wave1.svg";
import wave2 from "../media/wave2.svg";
import waveCards from "../media/wavecards.svg";
import waveDown1 from "../media/wavedown1.svg";
import WaveDown2 from "../media/wavedown2.svg";
import waveDown3 from "../media/wavedown3.svg";
import wordpress from "../media/wordpress.png";

export default{
    about,
    artemisa,
    bootstrap,
    css,
    css2,
    dev,
    fondoCss,
    git,
    git2,
    github,
    html,
    html2,
    javascript,
    javascript2,
    moviesWeb,
    nodejs,
    nodejs2,
    react,
    react2,
    wave1,
    wave2,
    waveCards,
    waveDown1,
    WaveDown2,
    waveDown3,
    wordpress
};